import script from "./ProjectHome.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectHome.vue?vue&type=script&setup=true&lang=js"

import "./ProjectHome.vue?vue&type=style&index=0&id=4d47ca9c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d47ca9c"]])

export default __exports__